import { z } from 'zod';
const partnerCode = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z0-9]{2,16}$/, 'Partner code must be 2–16 uppercase ASCII letters or digits');
export const createPartnerSchema = z.object({
    code: partnerCode,
    name: z.string().trim().min(1).max(200),
    contactPerson: z.string().trim().max(200).optional(),
    contactEmail: z.string().trim().toLowerCase().email().optional(),
    contactPhone: z.string().trim().max(40).optional(),
    billingAddress: z.string().trim().max(500).optional(),
    vatId: z.string().trim().max(40).optional(),
    defaultSlaWorkdays: z.number().int().min(0).max(365).default(5),
    allowOperatorOrders: z.boolean().default(false),
    placersSeeOrgOrders: z.boolean().default(true),
    notes: z.string().trim().max(2000).optional(),
    /** Storage billing mode for partner-owned pallets (Stage 2). */
    billingMode: z.enum(['PER_PALLET_DAY', 'FIXED_MONTHLY']).optional(),
    // Inline per-partner tariff (WMS-14): flat cents, interpreted by billingMode.
    customRateCents: z.number().int().min(0).max(100_000_000).nullable().optional(),
});
export const updatePartnerSchema = createPartnerSchema.partial().omit({ code: true });
//# sourceMappingURL=partner.js.map